var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWelcomeBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 63,
    viewBox: "0 0 232 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6121_433)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6121_433)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 224,
    height: 55,
    rx: 27.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.62 24.44C45.38 24.44 45.1733 24.5267 45 24.7C44.8267 24.8733 44.74 25.08 44.74 25.32V28.88C44.74 29.1333 44.8267 29.3467 45 29.52C45.1733 29.6933 45.38 29.78 45.62 29.78H52.62V28.58H49.42V25.84H55.58V32.5H45.58C45.0867 32.5 44.62 32.4067 44.18 32.22C43.7533 32.0333 43.3733 31.78 43.04 31.46C42.72 31.1267 42.4667 30.7467 42.28 30.32C42.0933 29.88 42 29.4133 42 28.92V25.28C42 24.7867 42.0933 24.3267 42.28 23.9C42.4667 23.46 42.72 23.08 43.04 22.76C43.3733 22.4267 43.7533 22.1667 44.18 21.98C44.62 21.7933 45.0867 21.7 45.58 21.7H55.58V24.44H45.62ZM59.5303 24.42V25.74H66.4503V28.46H59.5303V29.78H69.1303V32.5H56.5703V21.7H69.1303V24.42H59.5303ZM84.385 24.42H78.725V32.5H75.765V24.42H70.125V21.7H84.385V24.42ZM93.9589 24.44C93.7722 24.44 93.6122 24.5067 93.4789 24.64C93.3589 24.76 93.2989 24.9133 93.2989 25.1C93.2989 25.2867 93.3589 25.44 93.4789 25.56C93.6122 25.68 93.7722 25.74 93.9589 25.74H100.779C101.246 25.74 101.679 25.8333 102.079 26.02C102.492 26.1933 102.852 26.4333 103.159 26.74C103.466 27.0467 103.706 27.4067 103.879 27.82C104.052 28.22 104.139 28.6533 104.139 29.12C104.139 29.5867 104.052 30.0267 103.879 30.44C103.706 30.84 103.466 31.1933 103.159 31.5C102.852 31.8067 102.492 32.0533 102.079 32.24C101.679 32.4133 101.246 32.5 100.779 32.5H91.2989V29.76H100.559C100.746 29.76 100.899 29.7 101.019 29.58C101.152 29.46 101.219 29.3067 101.219 29.12C101.219 28.9333 101.152 28.78 101.019 28.66C100.899 28.5267 100.746 28.46 100.559 28.46H93.7389C93.2722 28.46 92.8322 28.3733 92.4189 28.2C92.0189 28.0267 91.6656 27.7867 91.3589 27.48C91.0522 27.1733 90.8122 26.8133 90.6389 26.4C90.4656 25.9867 90.3789 25.5467 90.3789 25.08C90.3789 24.6133 90.4656 24.18 90.6389 23.78C90.8122 23.3667 91.0522 23.0067 91.3589 22.7C91.6656 22.3933 92.0189 22.1533 92.4189 21.98C92.8322 21.7933 93.2722 21.7 93.7389 21.7H103.279V24.44H93.9589ZM118.584 24.42H112.924V32.5H109.964V24.42H104.324V21.7H118.584V24.42ZM127.579 31.14H119.659L118.839 32.5H115.379L121.879 21.7H125.339L131.839 32.5H128.399L127.579 31.14ZM125.939 28.42L123.619 24.56L121.299 28.42H125.939ZM142.314 32.5L138.294 28.48H135.194V32.5H132.234V21.7H142.394C142.861 21.7 143.301 21.7933 143.714 21.98C144.128 22.1533 144.488 22.3933 144.794 22.7C145.101 23.0067 145.341 23.3667 145.514 23.78C145.701 24.18 145.794 24.6133 145.794 25.08C145.794 25.5467 145.701 25.9867 145.514 26.4C145.341 26.8133 145.101 27.1733 144.794 27.48C144.488 27.7867 144.128 28.0333 143.714 28.22C143.301 28.3933 142.861 28.48 142.394 28.48H142.294L146.314 32.5H142.314ZM135.194 25.74H142.174C142.361 25.74 142.514 25.68 142.634 25.56C142.768 25.4267 142.834 25.2667 142.834 25.08C142.834 24.8933 142.768 24.74 142.634 24.62C142.514 24.4867 142.361 24.42 142.174 24.42H135.194V25.74ZM160.576 24.42H154.916V32.5H151.956V24.42H146.316V21.7H160.576V24.42ZM164.53 24.42V25.74H171.45V28.46H164.53V29.78H174.13V32.5H161.57V21.7H174.13V24.42H164.53ZM185.525 21.7C186.005 21.7 186.452 21.7933 186.865 21.98C187.278 22.1533 187.638 22.4 187.945 22.72C188.265 23.0267 188.512 23.3867 188.685 23.8C188.872 24.2133 188.965 24.66 188.965 25.14V29.06C188.965 29.54 188.872 29.9867 188.685 30.4C188.512 30.8133 188.265 31.18 187.945 31.5C187.638 31.8067 187.278 32.0533 186.865 32.24C186.452 32.4133 186.005 32.5 185.525 32.5H175.125V21.7H185.525ZM186.005 25.32C186.005 25.08 185.918 24.8733 185.745 24.7C185.572 24.5267 185.358 24.44 185.105 24.44H178.085V29.78H185.105C185.358 29.78 185.572 29.6933 185.745 29.52C185.918 29.3467 186.005 29.1333 186.005 28.88V25.32Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6121_433",
    x: 0,
    y: 0,
    width: 232,
    height: 63,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6121_433"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6121_433",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6121_433"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 224,
    height: 55,
    rx: 27.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeBtn);
export default __webpack_public_path__ + "static/media/WelcomeBtn.389a46a9a50921a4d4851db33601cbf4.svg";
export { ForwardRef as ReactComponent };